import { render, staticRenderFns } from "./SysMsgSpace.vue?vue&type=template&id=bb6de0d0&"
import script from "./SysMsgSpace.vue?vue&type=script&lang=js&"
export * from "./SysMsgSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports